type Dict = { [k: string]: string | Dict };
export const es = {
  mapHint: {
    hintPrefix: "Maya:",
    hint: "Toca un punto brillante y te muestro las mejores experiencias.",
    oneAvailable: "experiencia disponible",
    manyAvailable: "experiencias disponibles",
    comingSoon: "Próximamente experiencias",
    tapClear: "Toca de nuevo para limpiar.",
    tapExplore: "Haz clic para explorar.",
  },
  mayaHome: {
    sectionEyebrow: "Exclusivo de Mostrando México",
    sectionTitle: "Descubre México con Maya",
    sectionDescription:
      '"Reserva como en cualquier plataforma. Descubre México como en ninguna otra."',
    mayaName: "Maya",
    mayaRole: "Tu guía virtual de México",
    intro:
      "Maya es la guía virtual de Mostrando México. Descubre historias fascinantes, cultura, gastronomía, naturaleza y curiosidades de los destinos más increíbles de México.",
    feat1: "Historia y Leyendas",
    feat2: "Cultura y Tradiciones",
    feat3: "Gastronomía Regional",
    feat4: "Flora y Fauna",
    feat5: "Geografía y Curiosidades",
    feat6: "Guías Narradas por Maya",
    ctaMeet: "Conoce a Maya",
    ctaSample: "Escuchar una muestra",
    premiumBadge: "Guías de Maya",
    premiumTitle: "Guías de Maya",
    premiumDesc:
      "Convierte cada viaje en una experiencia más completa con las guías narradas de México.",
    singleDest: "Destino individual",
    passAll: "Maya Pass · todas las guías disponibles",
    unlock: "Ver Guías de Maya",
    exclusive: "Disponible exclusivamente a través de Mostrando México.",
  },
  mayaHub: {
    heroEyebrow: "Guías de Maya",
    heroTitle: "México, contado por Maya.",
    heroSubtitle: "Guías narradas de destinos de México, en tu idioma.",
    heroCtaPrimary: "Descubrir Maya Pass",
    heroCtaSecondary: "Explorar destinos",
    statsDestinations: "destinos",
    statsUniverses: "universos",
    statsLanguages: "idiomas",
    categoriesEyebrow: "Universos temáticos",
    categoriesTitle: "Elige el México que quieres vivir hoy",
    categoriesDescription:
      "Cada universo agrupa destinos con una misma alma. Toca uno y deja que Maya te guíe.",
    destinationsEyebrow: "Destinos destacados",
    destinationsTitle: "Historias narradas, listas para ti",
    destinationsDescription:
      "Guías inmersivas creadas para viajar con más contexto, más emoción y más significado.",
    destinationsEmpty:
      "Estamos preparando los primeros destinos narrados. Muy pronto los escucharás aquí.",
    searchPlaceholder: "Buscar destino o estado…",
    filterAll: "Todos",
    clearFilters: "Limpiar filtros",
    resultsCount: "{{count}} destinos",
    noResults: "No encontramos destinos con esos filtros.",
    filterByState: "Filtrar por estado",
    allStates: "Todos los estados",
    showMore: "Ver más destinos",
    showingCount: "Mostrando {{shown}} de {{total}}",
    comingSoon: "Próximamente",
    exploreAll: "Ver todos los destinos",
    plansEyebrow: "Elige tu plan",
    plansTitle: "Dos formas de viajar con Maya",
    plansDescription: "Sin suscripciones. Paga una vez y disfruta.",
    planSingleName: "Maya Destino",
    planSinglePrice: "$2.99 USD",
    planSingleTag: "un destino",
    planSingleDesc: "Guía narrada completa de un destino específico.",
    planPassName: "Maya Pass México",
    planPassPrice: "$9.99 USD",
    planPassTag: "todos los destinos",
    planPassDesc: "Todas las Guías de Maya disponibles ({{count}} hoy) y las que agreguemos, sin fecha de vencimiento.",
    planPassRibbon: "Mejor valor",
    planIncludes: "Incluye:",
    ctaBuySingle: "Elegir un destino",
    ctaBuyPass: "Obtener Maya Pass",
    finalTitle: "¿Listo para vivir un México más profundo?",
    finalDesc: "Escucha la muestra gratis y elige tu guía.",
    finalCta: "Empezar ahora",
  },

  mapControls: {
    zoomIn: "Acercar",
    zoomOut: "Alejar",
    home: "Inicio",
  },
  common: {
    book: "Reservar",
    bookNow: "Reservar ahora",
    viewAll: "Ver todos",
    loading: "Cargando…",
    from: "",
    backToTours: "Volver a tours",
    perPerson: "/persona",
    seeMore: "Ver más",
    seeOnMaps: "Ver en Google Maps",
    language: "Idioma",
    currency: "Moneda",
    refund48h: "Cancelación según cada tour",
  },
  nav: {
    explora: "Explora México",
    tours: "Tours",
    flights: "Vuelos",
    inspiration: "Blog",
    login: "Iniciar sesión",
    logout: "Cerrar sesión",
    book: "Reservar",
    myAccount: "Mi cuenta",
    myProfile: "Mi perfil",
    myBookings: "Mis reservas",
    admin: "Panel administrativo",
    cart: "Carrito",
    search: "Buscar",
    menu: "Menú",
    backHome: "Volver al inicio",
    bottom: {
      aria: "Navegación principal",
      home: "Inicio",
      search: "Buscar",
      discounts: "Descuentos",
      maya: "Maya",
      audioguide: "Guías de Maya",
      profile: "Perfil",
    },
  },
  footer: {
    explore: "Explorar",
    company: "Empresa",
    help: "Ayuda",
    toursMx: "Tours en México",
    needFlight: "¿Necesitas vuelo?",
    cheapFlights: "¿Necesitas vuelo?",
    travelGuides: "Guías de viaje",
    about: "Sobre nosotros",
    contact: "Contacto",
    systemStatus: "Estado del sistema",
    helpCenter: "Centro de ayuda",
    cancellationPolicy: "Política de cancelación",
    privacy: "Privacidad",
    cookiePrefs: "Preferencias de cookies",
    terms: "Términos",
    tagline: "Tours y experiencias en el Caribe mexicano y Yucatán, con disponibilidad real y operadores locales.",
    madeIn: "Hecho con orgullo en México",
    rights: "Todos los derechos reservados.",
  },
  home: {
    heroEyebrow: "Caribe mexicano y Yucatán",
    heroTitlePre: "Tours en el Caribe mexicano",
    heroTitleEm: "y Yucatán",
    heroTitlePost: "",
    heroSubtitle: "Tours en cenotes, ruinas e islas, con reserva directa con el operador.",
    destinationsEyebrow: "Empieza por aquí",
    destinationsTitle: "Elige tu destino",
    destinationsDesc: "Descubre los lugares más amados de México y arma tu viaje desde ahí.",
    destinationLabel: "Destino",
    highlightsEyebrowPrefix: "Lo mejor de",
    highlightsTitle: "Experiencias seleccionadas",
    highlightsDesc: "Tours favoritos para empezar a planear tu viaje.",
    highlightsLinkPrefix: "Ver tours en",
    valueEyebrow: "Por qué viajar con nosotros",
    valueTitle: "Tu viaje, sin estrés",
    value: {
      priceTitle: "Reserva directa con el operador",
      priceDesc: "Tratas directamente con quien opera el tour.",
      bookingTitle: "Reserva segura",
      bookingDesc: "Pagos cifrados con Stripe. Cada tour indica su política de cancelación.",
      supportTitle: "Atención 24/7 por WhatsApp",
      supportDesc: "Escríbenos a cualquier hora, todos los días.",
      verifiedTitle: "Experiencias verificadas",
      verifiedDesc: "Operadores locales y reseñas reales.",
    },
    reviewsEyebrow: "Lo que dicen",
    reviewsTitle: "Viajeros felices",
    faqEyebrow: "Resolvemos tus dudas",
    faqTitle: "Preguntas frecuentes",
  },
  search: {
    tours: "Tours",
    flights: "Vuelos",
    whereTours: "¿A dónde vas?",
    originDest: "Origen → Destino",
    placeholderTours: "Tulum, CDMX, cenotes…",
    placeholderFlights: "CUN, MEX, GDL…",
    date: "Fecha",
    departure: "Salida",
    passengers: "Pasajeros",
    person: "persona",
    persons: "personas",
    search: "Buscar",
  },
  toursList: {
    title: "Tours y experiencias",
    countSuffix: "experiencias auténticas operadas por locales en todo México.",
    curatedBy: "curadas por Mostrando México",
    searchPlaceholder: "Buscar destino, actividad o experiencia…",
    byState: "Por entidad federativa",
    allCategories: "Todas las categorías",
    foundOne: "experiencia encontrada",
    foundMany: "experiencias encontradas",
    emptyTitle: "Sin resultados",
    emptyDesc: "Prueba con otros términos o quita los filtros.",
    showingPrefix: "Mostrando",
    showingSuffix: "Refina tu búsqueda para más precisión.",
  },
  recentTour: {
    title: "Continúa donde te quedaste",
    again: "Ver nuevamente",
    dismiss: "Descartar",
    gone: "Esta fecha ya no está disponible. Elige otra opción",
  },
  tourV2: {
    privateGroup: "Grupo privado",
    perGroup: "por grupo",
    upToPeople: "Hasta {{count}} personas",
    howManyPeople: "¿Cuántas personas viajarán?",
    groupLimit: "El precio cubre un grupo de hasta {{count}} personas. Para más personas, contáctanos.",
    people: "personas",
    free: "Gratis",
    related: "También te puede gustar",
    confirmPending: "Estamos verificando tu reserva.",
    stepData: "Tus datos",
    stepPay: "Pago",
    stepConfirm: "Confirmación",
    cat: {
      ADULT: "Adultos",
      CHILD: "Niños",
      INFANT: "Infantes",
      TEENAGER: "Adolescentes",
      SENIOR: "Adultos mayores",
      STUDENT: "Estudiantes",
      YOUTH: "Jóvenes",
      MILITARY: "Militares",
      GROUP: "Grupo",
      OTHER: "Otros",
    },
    participants: "Participantes",
    age: "edad",
    noPrices: "Selecciona una fecha para ver las tarifas reales.",
    minPax: "Mínimo {{count}} participantes.",
    feesAtDestination: "Cargos que se pagan en el destino",
    continueToBook: "Continuar a reservar",
    seeDatesBook: "Ver fechas y reservar",
    backToPrices: "Volver a precios",
    officialBook: "Ver disponibilidad y reservar",
    officialPriceTitle: "Precio final",
    officialNote: "El precio final, incluidos los gastos de reserva aplicables, se mostrará antes de confirmar el pago.",
    prices: "Precios",
    pricesFrom: "Precios",
    live: "En vivo",
    pricesIn: "Precios en {{currency}}",
    officialNextDate: "Pr\u00f3xima fecha disponible",
    officialDepartures: "Salidas",
    officialNoPrices: "Consulta los precios en la ventana de reserva.",
    officialLoading: "Consultando precios oficiales\u2026",
    step1: "Tu selección",
    step2: "Tus datos",
    step3: "Pago",
    bookTitle: "Reserva tu experiencia",
    firstName: "Nombre",
    lastName: "Apellidos",
    email: "Correo electrónico",
    phone: "Teléfono",
    country: "País",
    pickup: "Punto de recogida",
    noPickup: "Sin recogida",
    hotelNote: "Hotel o indicaciones (opcional)",
    breakdown: "Desglose del precio",
    pickupChoose: "Elige o escribe tu hotel",
    hotelRequired: "Hotel o punto de recogida",
    pickupRequiredError: "Este tour incluye recogida: indica tu hotel o punto de recogida.",
    dropoff: "Punto de regreso",
    dropoffOptional: "Punto de regreso (opcional)",
    sameAsPickup: "Usar el mismo lugar de recogida",
    dropoffRequiredError: "Indica dónde te dejamos al terminar el tour.",
    processing: "Procesando pago…",
    securePayment: "Pago seguro cifrado con Stripe",
    checkoutDisabled: "El pago en línea no está disponible en este momento. Escríbenos por WhatsApp para reservar.",
    payError: "No pudimos iniciar el pago. Inténtalo de nuevo.",
    priceChanged: "El precio o la disponibilidad cambió. Revisa el nuevo total y confírmalo para continuar.",
    goToPayment: "Continuar al pago",
    pay: "Pagar",
    phaseHolding: "Apartando tu lugar…",
    phasePreparing: "Preparando pago seguro…",
    willCharge: "Se cobrará",
    continueSecure: "Continuar al pago seguro",
    continueWith: "Continuar con",
    editSelection: "Editar selección",
    back: "Atrás",
    nav: {
      summary: "Resumen",
      before: "Antes de viajar",
      faq: "Preguntas frecuentes",
      aria: "Secciones del tour",
    },
    pickDay: "Elige tu día",
    times: "Horarios disponibles",
    travellers: "Viajeros",
    moreTravellers: "Añadir viajero",
    lessTravellers: "Quitar viajero",
    priceFrom: "Precio por persona",
    total: "Total",
    fees: "Ver cargos adicionales",
    noFeesReported:
      "El proveedor no reporta cargos adicionales para este tour. El importe final se confirma en el paso de reserva.",
    checkAvailability: "Ver disponibilidad",
    loadingDates: "Consultando disponibilidad real…",
    noDates: "No hay fechas disponibles en este mes.",
    seeExperience: "Ver experiencia",
    pickDate: "Elegir fecha",
    needDate: "Selecciona una fecha",
    needTime: "Selecciona un horario",
    needPax: "Añade viajeros",
    bookNowCta: "Reservar ahora",
    meetMaya: "Conocer a Maya",
    escapeTo: "Escápate a {{place}}",
    phraseDay: "Un día que recordarás siempre",
    phraseShort: "Una experiencia que recordarás siempre",
    dayTour: "Tour de día",
    activity: "Actividad",
    showMap: "Ver mapa",
    hideMap: "Ocultar mapa",
    faqAccessibility: "Accesibilidad",
    faqDressCode: "Qué llevar",
    faqCondition: "Condición física",
    mayaAlt: "Maya, tu guía digital",
    mayaSubtitle: "Tu guía digital para este recorrido",
    mayaClose: "Volver al calendario",
    mayaGuide: "Guía de Maya",
    mayaLocked: "La guía completa y su descarga se activan al confirmarse tu reserva pagada.",
    mayaUnlocked: "Tu guía completa está disponible en tu reserva confirmada.",
    mayaLanguage: "Idioma de la guía",
    ownCheckoutOnly: "Completa tu reserva en el panel de la derecha.",
    features: {
      archaeology: "Arqueología",
      boat: "Paseo en lancha",
      sea: "Mar turquesa",
      snorkel: "Snorkel",
      nature: "Naturaleza",
      wildlife: "Fauna",
      cenote: "Cenotes",
      culture: "Cultura",
      food: "Comida",
      transport: "Transporte",
      guide: "Guía",
      photos: "Fotos",
      sunset: "Atardecer",
    },
  },
  tour: {
    from: "",
    noReviews: "A\u00fan no hay rese\u00f1as. \u00a1S\u00e9 el primero en compartir tu experiencia!",
    notFound: "Tour no encontrado",
    notFoundDesc: "El enlace no es válido o el tour ya no está disponible.",
    seeAll: "Ver todos los tours",
    difficulty: "Dificultad",
    minAge: "Edad mín.",
    highlights: "Lo destacado",
    itinerary: "Itinerario",
    includes: "Incluye",
    excludes: "No incluye",
    importantInfo: "Información importante",
    requirements: "Qué llevar / requisitos",
    beforeBooking: "Antes de reservar",
    meetingPoint: "Punto de encuentro",
    cancellation: "Política de cancelación",
    operatedBy: "Operado por",
    extraDetails: "Detalles adicionales",
    guideLanguages: "Idiomas del guía",
    audio: "Audio",
    subtitles: "Subtítulos",
    voucher: "Voucher",
    voucherPrinted: "(impreso requerido)",
    dressCode: "Código de vestimenta",
    physicalCondition: "Condición física",
    accessibility: "Accesibilidad",
    restrictions: "Restricciones",
    productCode: "Código de producto",
    operatorContact: "Contacto del operador",
    email: "Email",
    phone: "Teléfono",
    website: "Web",
    difficulties: { EASY: "Fácil", MODERATE: "Moderada", CHALLENGING: "Exigente" },
    meetingTypes: {
      MEET_ON_LOCATION: "Punto de encuentro en el lugar",
      MEET_ON_LOCATION_OR_PICK_UP: "Punto de encuentro o pickup en hotel",
      PICK_UP: "Pickup en tu hotel",
    },
    waMessage: 'Hola, estoy interesado/a en el tour "{{title}}". ¿Me pueden dar más información?',
    discover: {
      heading: "Descubre este destino",
      subheading: "Historia, cultura y naturaleza del lugar — no recomendaciones comerciales.",
      loading: "Preparando tu mini-guía cultural…",
      didYouKnow: "Sabías que…",
      assistantTitle: "Pregúntale al guía IA",
      assistantSubtitle:
        "Pregunta sobre {{destination}}: historia, fauna, leyendas, mejor época para visitar…",
      placeholder: "¿Qué te gustaría saber sobre {{destination}}?",
      send: "Preguntar",
      thinking: "Pensando…",
      welcome: "Hola, soy tu guía cultural de {{destination}}. ¿Qué te gustaría descubrir?",
      error: "No pude responder ahora. Intenta de nuevo.",
      suggestions: {
        s1: "¿Qué hace especial este lugar?",
        s2: "¿Cuál es su historia?",
        s3: "¿Qué especies puedo observar?",
        s4: "¿Por qué es famoso?",
        s5: "¿Cuál es la mejor época para visitarlo?",
        s6: "¿Qué debo saber antes de ir?",
      },
      sectionTitles: {
        history: "Historia",
        culture: "Cultura",
        traditions: "Tradiciones",
        fauna_flora: "Fauna y flora",
        gastronomy: "Gastronomía típica",
        legends: "Leyendas locales",
        customs: "Costumbres",
        geography: "Geografía",
      },
    },
  },
  booking: {
    officialTitle: "Reserva oficial",
    officialLabel: "Reserva oficial",
    securePayment: "Pago seguro",
    chooseDate: "Elige tu fecha",
    secureBooking: "Reserva segura",
    managedBy: "Reserva y pago seguros.",
    changeLangCurrency: "Cambiar idioma/moneda",
  },
  heroHome: {
    navExplora: "Explora México",
    navTours: "Tours",
    navVerde: "México Verde",
    navVuelos: "Vuelos",
    navGuia: "Guías de Maya",
    login: "Iniciar sesión",
    myAccount: "Mi cuenta",
    searchAria: "Buscar destinos",
    searchClose: "Cerrar buscador",
    searchEyebrow: "Buscar",
    searchTitle: "Encuentra tu próxima experiencia",
    searchPlaceholder: "Buscar tours, destinos o experiencias…",
    searchSubmit: "Buscar",
    searchPopular: "Destinos populares",
    heroQuestion: "¿Qué quieres vivir",
    heroToday: "hoy?",
    heroSubtitle:
      "Descubre experiencias únicas por todo México con ayuda de Maya, tu guía inteligente.",
    heroEyebrow: "Mostrando México · Maya",
    destAll: "Todos",
    destFilterAria: "Filtrar tours por destino",
    destPrevAria: "Más destinos a la izquierda",
    destNextAria: "Más destinos a la derecha",
    destChooseEyebrow: "Empieza por aquí",
    destChooseTitle1: "Elige tu",
    destChooseTitleEm: "destino",
    destChooseDesc: "Toca un destino y Maya y el mapa se actualizan al instante.",
    destChooseCta: "Ver todos",
    mayaCtaPrefix: "",
    mayaCtaHighlight: "Te ayudo a elegir",
  },
  reto: {
    eyebrow: "Reto interactivo",
    title: "¿Crees conocer México?",
    desc: "Responde nuestro reto y desbloquea descuentos exclusivos para tu próxima aventura. Acierta todas y gana hasta un 15% de descuento.",
    badge5: "5 preguntas · 10%",
    badge10: "10 preguntas · 15%",
    cta: "Comenzar reto",
  },
  catalogPage: {
    loadError: 'No pudimos cargar los tours en este momento.',
    retry: 'Reintentar',
    title: "Tours y experiencias",
    subtitle: "{{count}} experiencias aut\u00e9nticas operadas por locales en todo M\u00e9xico.",
    curated: "\u00b7 {{count}} curadas por Mostrando M\u00e9xico",
    searchPlaceholder: "Buscar destino, actividad o experiencia\u2026",
    byState: "Por entidad federativa",
    seeAll: "Ver todos \u2192",
    allCategories: "Todas las categor\u00edas",
    foundOne: "{{count}} experiencia encontrada",
    foundMany: "{{count}} experiencias encontradas",
    emptyTitle: "No encontramos experiencias con estos filtros",
    clearFilters: "Quitar filtros",
    seeAllExperiences: "Ver todas las experiencias",
    showingLimit:
      "Mostrando {{shown}} de {{total}}. Refina tu b\u00fasqueda para m\u00e1s precisi\u00f3n.",
    allDestinations: "Todos los destinos",
    toursIn: "Tours en {{name}}",
    availableOne: "experiencia disponible",
    availableMany: "experiencias disponibles",
    stateLabel: "Entidad federativa",
    comingSoon: "Pronto a\u00f1adiremos experiencias en {{name}}",
    comingSoonDesc: "Mientras tanto, explora todos nuestros tours en M\u00e9xico.",
    seeAllTours: "Ver todos los tours",
    sortBy: "Ordenar por",
    sortFeatured: "Destacados",
    sortPrice: "Precio",
    sortPopularity: "Popularidad",
    sortDuration: "Duraci\u00f3n",
    logoTagline: "tours · experiencias",
    imageUnavailable: "Imagen no disponible",
  },
  destTagline: {
    "las-coloradas": "Las famosas lagunas rosadas teñidas por microorganismos.",
    "rio-lagartos": "Reserva natural de flamencos, cocodrilos y manglares.",
    guanajuato: "Callejones coloridos y patrimonio colonial vivo.",
    izamal: "La Ciudad Amarilla y su convento franciscano.",
    palenque: "Ruinas mayas en la selva, cascadas turquesa y biodiversidad.",
    teotihuacan: "La Ciudad de los Dioses: pirámides del Sol y la Luna.",
    cancun: "Caribe turquesa, vida nocturna y aventura submarina.",
    tulum: "Ruinas frente al mar, cenotes y la mejor energía boho.",
    "playa-del-carmen": "Quinta avenida, snorkel y la puerta a Cozumel.",
    cozumel: "El paraíso del buceo y los arrecifes del Caribe.",
    "isla-mujeres": "Playa Norte, ballena tiburón y atardeceres irrepetibles.",
    holbox: "Isla virgen, flamencos y noches bioluminiscentes.",
    bacalar: "La laguna de los siete colores y los estromatolitos.",
    "chichen-itza": "Maravilla del mundo maya, cenotes y Valladolid.",
    valladolid: "Pueblo mágico, cenotes secretos y gastronomía yucateca.",
    merida: "Capital blanca de Yucatán, haciendas y ruta puuc.",
    oaxaca: "Mezcal, mole y los pueblos artesanos más vivos de México.",
    cdmx: "Megalópolis con museos, mercados y rooftops legendarios.",
    "los-cabos": "El Arco, ballenas grises y desierto frente al Pacífico.",
    "puerto-vallarta": "Malecón, Sierra Madre y playas vírgenes en Yelapa.",
    "quintana-roo": "El Caribe mexicano: cenotes, ruinas y arena blanca.",
    yucatan: "Mundo maya, cenotes secretos y haciendas henequeneras.",
    "baja-california-sur": "Mar de Cortés, ballenas y desierto frente al Pacífico.",
    jalisco: "Mariachi, tequila y playas del Pacífico.",
  },
  destinosPage: {
    destinosTitle: "Destinos en México",
    destinosSubtitle: "Explora experiencias organizadas por entidad federativa.",
    noDestinations: "Sin destinos para esa búsqueda",
    guidesTitle: "Guías de destino",
    guidesSubtitle: "Historia, geografía, gastronomía y tours por destino.",
  },
  homeUi: {
    popularEyebrow: "Destinos populares",
    popularTitle: "Elige a dónde quieres ir",
    allDestinations: "Ver todos los destinos",
    featuredEyebrow: "Experiencias destacadas",
    featuredTitle: "Las más reservadas ahora",
    allExperiences: "Ver todas las experiencias",
    allOffers: "Ver todas las ofertas",
    carouselFeatured: "Experiencias destacadas",
    carouselIn: "Experiencias en {{name}}",
    viewAll: "Ver todas",
    askAvailability: "Consultar disponibilidad",
  },
  badges: {
    bestseller: "Más vendido",
    recommended: "Recomendado",
    unmissable: "Imperdible",
    new: "Nuevo",
    offer: "Oferta",
    featured: "Destacado",
    mayaPick: "Recomendado por Maya",
  },
  whispers: {
    akumal: "En Akumal se puede nadar con tortugas marinas. Pregúntame cómo.",
    chichen: "Chichén Itzá es una de las experiencias más reservadas de la Riviera.",
    bacalar: "Bacalar y sus siete tonos de azul: ideal para atardeceres.",
    holbox: "Holbox es la isla sin prisa del Caribe mexicano.",
    cenote: "Sé de tres cenotes que casi nadie conoce. Pregúntame.",
    vallarta: "En temporada, las ballenas jorobadas visitan Vallarta.",
    cabos: "El Arco de Los Cabos se ve mejor al amanecer.",
    tulum: "Tulum a las 7am es otra ciudad. La mejor.",
    foundOne: "Encontré {{count}} experiencia en {{name}}.",
    found: "Encontré {{count}} experiencias en {{name}}.",
  },
  destLines: {
    cancun: "Cancún tiene playas caribeñas y arrecifes vivos. Elige un tour para empezar.",
    tulum: "Tulum es perfecto para cenotes, ruinas mayas y playas de ensueño.",
    "playa-del-carmen": "Playa del Carmen combina Quinta Avenida, arrecifes y vida nocturna.",
    cozumel: "Cozumel es la meca del buceo del Caribe mexicano.",
    "isla-mujeres": "Isla Mujeres huele a mar en calma, snorkel y atardeceres únicos.",
    holbox: "Holbox es ideal para naturaleza, flamencos y tranquilidad absoluta.",
    bacalar: "Bacalar y su Laguna de los Siete Colores te dejarán sin aliento.",
    "chichen-itza": "Chichén Itzá guarda la pirámide de Kukulcán y el cenote sagrado.",
    merida: "Mérida es la capital blanca: cultura, gastronomía y haciendas mayas.",
    oaxaca: "Oaxaca es mezcal, mole y los pueblos artesanos más vivos de México.",
    cdmx: "Ciudad de México: museos icónicos, mercados y rooftops legendarios.",
    "los-cabos": "Los Cabos: El Arco, ballenas grises y desierto frente al Pacífico.",
    "puerto-vallarta": "Puerto Vallarta: Malecón, Sierra Madre y playas en Bahía de Banderas.",
  },
  orbitUi: {
    mayaLabel: "Recomiéndame",
    mayaShort: "Habla con Maya",
    mayaWhisper: "Cuéntame qué quieres vivir.",
    helpLabel: "Ayuda",
    helpShort: "Preguntas frecuentes",
    helpWhisper: "¿Necesitas una mano? Estoy aquí.",
  },
  gallery: {
    viewAll: "Ver todas",
    viewAllPhotos: "Ver todas las fotos",
  },
  homeExtra: {
    expOne: "{{count}} experiencia",
    expMany: "{{count}} experiencias",
    whyTravel: "Por qué viajar con nosotros",
    trustRefundTitle: "Política de cancelación clara",
    trustRefundDesc: "Cada tour muestra su política antes de pagar.",
    trustSecureTitle: "Reserva segura",
    trustSecureDesc: "Pagos protegidos y proceso confiable.",
    trustSupportTitle: "Atención 24/7 por WhatsApp",
    trustSupportDesc: "Escríbenos a cualquier hora, todos los días.",
    viewDetails: "Ver detalles",
  },
  catLabels: {
    playa: "Playas",
    cultura: "Cultura",
    naturaleza: "Naturaleza",
    aventura: "Aventura",
    islas: "Islas",
    arqueologia: "Ruinas",
    gastronomia: "Gastronomía",
    cenotes: "Cenotes",
    "cultura-maya": "Mundo maya",
    "vida-nocturna": "Vida nocturna",
    familiar: "Familia",
    romance: "Romance",
  },
  decor: {
    arrecife: "Arrecife",
    atardecer: "Atardecer",
    ballenas: "Ballenas",
    buceo: "Buceo",
    calendario: "Calendario",
    "capital-blanca": "Capital blanca",
    capital: "Capital",
    caracol: "Caracol",
    caribe: "Caribe",
    catamaran: "Catamarán",
    cenote: "Cenote",
    centro: "Centro",
    colonial: "Colonial",
    cultura: "Cultura",
    desierto: "Desierto",
    destino: "Destino",
    "el-arco": "El Arco",
    explorar: "Explorar",
    flamenco: "Flamenco",
    guelaguetza: "Guelaguetza",
    kayak: "Kayak",
    kukulkan: "Kukulkán",
    laguna: "Laguna",
    mar: "Mar",
    marina: "Marina",
    mezcal: "Mezcal",
    "mundo-maya": "Mundo maya",
    mexico: "México",
    olas: "Olas",
    pacifico: "Pacífico",
    palmeras: "Palmeras",
    "punta-sur": "Punta Sur",
    ruinas: "Ruinas",
    selva: "Selva",
    sierra: "Sierra",
    snorkel: "Snorkel",
    "sol-maya": "Sol maya",
    "tiburon-ballena": "Tiburón ballena",
    tortugas: "Tortugas",
    trova: "Trova",
    velero: "Velero",
  },
  bookingFlow: {
    checkout: {
      back: "← Volver al carrito",
      title: "Finalizar reserva",
      testMode:
        "Modo prueba activo. Usa la tarjeta 4242 4242 4242 4242, cualquier fecha futura, cualquier CVC y cualquier código postal. No se cobrará dinero real.",
      holder: "Datos del titular",
      firstName: "Nombre",
      lastName: "Apellido",
      email: "Email",
      phone: "Teléfono (opcional)",
      country: "País",
      language: "Idioma",
      empty: "Tu carrito está vacío.",
      seeTours: "Ver tours",
      preparing: "Preparando pago…",
      continueLabel: "Continuar",
      summary: "Resumen",
      total: "Total",
      payNote:
        "El pago se realiza con tarjeta en esta página. Al completarlo recibirás la confirmación por correo.",
      notConfigured: "Pagos no configurados en este entorno.",
      startError: "No se pudo iniciar el pago",
      required: "Requerido",
      invalidEmail: "Email inválido",
    },
    panel: {
      date: "Fecha",
      time: "Horario",
      travelers: "Viajeros",
      noFares: "No hay tarifas configuradas para esta fecha.",
      extras: "Extras",
      requiredExtra: "(incluido obligatorio)",
      perPerson: "/ persona",
      perBooking: "/ reserva",
      meetingPoint: "Punto de encuentro o recogida",
      pickup: "Recogida",
      total: "Total",
      book: "Reservar",
      pay: "Pagar",
      preparing: "Preparando pago…",
      stayTitle: "Datos de hospedaje y llegada",
      hotel: "Hotel",
      hotelAddress: "Dirección del hotel (opcional)",
      room: "Habitación (opcional)",
      flight: "Número de vuelo",
      arrival: "Hora de llegada (opcional)",
      firstName: "Nombre",
      lastName: "Apellido",
      email: "Email",
      phone: "Teléfono (opcional)",
      select: "Selecciona…",
      terms: "Acepto los términos y condiciones y la política de cancelación.",
      minPax: "Mínimo {{count}} viajeros.",
      maxPax: "Máximo {{count}} viajeros por reserva.",
      available: "disp.",
      noDates:
        "Próximamente hay nuevas fechas disponibles. Contáctanos para reservar este tour de manera personalizada.",
      seasonRate: "Tarifa {{name}}",
      minus: "Restar",
      plus: "Sumar",
    },
    tiers: {
      adult: "Adultos",
      child: "Niños",
      infant: "Infantes",
      student: "Estudiante",
      senior: "Adultos mayores",
      private: "Privado",
      group: "Grupal",
    },
    ret: {
      confirming: "Confirmando tu reserva…",
      syncBokun: "Estamos confirmando tu reserva. Esto puede tardar unos segundos.",
      verifying: "Estamos verificando tu pago. Esto puede tardar unos segundos.",
      confirmed: "¡Reserva confirmada!",
      redirecting: "Redirigiendo a tu voucher…",
      paid: "Pago recibido",
      paidNote: "Tu pago se recibió y estamos confirmando la reserva.",
      reference: "Referencia",
      viewStatus: "Ver el estado de mi reserva",
      errorTitle: "No se pudo confirmar la reserva",
      errorHelp: "Si el cobro se realizó, contáctanos y te ayudaremos a resolverlo de inmediato.",
      home: "Volver al inicio",
      missingSession: "Falta el identificador de la sesión de pago.",
      notConfirmedYet: "El pago aún no se confirma.",
    },
    voucher: {
      back: "← Inicio",
      statusConfirmed: "CONFIRMADA",
      readyLine: "Tu experiencia está lista",
      confirmedTitle: "Reserva confirmada",
      createdTitle: "Reserva creada",
      notFoundTitle: "No encontramos esta reserva",
      notFoundBody:
        "Revisa el código en tu correo de confirmación. Si crees que hay un error, contáctanos.",
      demoTitle: "Vista previa (demo)",
      demoNote:
        "Esta es una vista previa de cómo verá el cliente su confirmación, voucher, QR y ticket.",
      saveCode: "Guarda este código para futuras consultas.",
      activity: "Actividad",
      date: "Fecha",
      travelers: "Viajeros",
      total: "Total",
      status: "Estado",
      meetingPoint: "Punto de encuentro",
      extras: "Extras",
      customer: "Cliente",
      operatorCode: "Código del operador",
      loadError: "No se pudo cargar la reserva",
      pending: "Estamos confirmando esta reserva.",
    },
  },
  homeV2: {
    a8: "Mostrando México procesa los pagos con Stripe. En el recibo puede aparecer MMEXICO y en tu estado de cuenta LADYGUIA; ambos corresponden a la misma operación.",
    benefitsAria: "Beneficios de reserva",
    secureTitle: "Reserva segura",
    secureDesc: "Pagos protegidos y confirmación inmediata.",
    flexTitle: "Política de cancelación clara",
    flexDesc: "Cada tour muestra su política antes de pagar.",
    supportTitle: "Atención 24/7 por WhatsApp",
    supportDesc: "Escríbenos a cualquier hora, todos los días.",
    destEyebrow: "Destinos populares",
    destTitle: "Elige a dónde quieres ir",
    destAll: "Ver todos los destinos",
    expOne: "{{count}} experiencia",
    expMany: "{{count}} experiencias",
    topEyebrow: "Las más reservadas ahora",
    topTitle: "Experiencias que están conquistando México",
    topAll: "Ver todas las experiencias",
    operatedOwn: "Operado por Mostrando México",
    operatedPartner: "Proveedor asociado",
    cancelNote: "Consulta las condiciones de cancelación de esta actividad.",
    from: "",
    askAvailability: "Consultar disponibilidad",
    viewDetails: "Ver detalles",
    inspirationAria: "Inspiración por destino",
    carousel: "carrusel",
    slide: "diapositiva",
    explore: "Explorar {{name}}",
    goTo: "Ir a {{name}}",
    phraseBacalar: "Siete tonos de azul para un atardecer inolvidable.",
    phraseHolbox: "Una isla donde el tiempo parece detenerse.",
    phraseCozumel: "Arrecifes, estrellas de mar y aguas cristalinas.",
    phraseChichen: "Descubre una de las maravillas del mundo maya.",
    phraseVallarta: "Montañas, mar y experiencias llenas de aventura.",
    phraseCancun: "El punto de partida para vivir el Caribe mexicano.",
    mayaTitle: "Descubre México con Maya",
    mayaDesc:
      "Tu guía inteligente para descubrir experiencias, diseñar tu viaje y conocer México de una forma diferente.",
    opt1Title: "Pregúntale a Maya",
    opt1Desc: "Resuelve tus dudas y recibe recomendaciones al instante.",
    opt2Title: "Diseña tu viaje",
    opt2Desc: "Cuéntale tus intereses y crea un itinerario personalizado.",
    opt3Title: "Guías de Maya",
    opt3Desc: "Accede a guías narradas, historias y beneficios especiales.",
    mayaCta: "Hablar con Maya",
    finalTitle: "¿No sabes qué elegir?",
    finalDesc: "Maya te recomienda una experiencia en 30 segundos.",
    finalCta: "Preguntarle a Maya",
    reviewsEyebrow: "Viajeros felices",
    reviewsTitle: "Lo que dicen de nosotros",
    reviewVerified: "Reseña verificada · Mostrando México",
    ratingOf: "{{n}} de 5",
    faqEyebrow: "Resolvemos tus dudas",
    faqTitle: "Preguntas frecuentes",
    q1: "¿Cómo hago una reserva?",
    a1: "Elige la experiencia, selecciona fecha y número de viajeros y completa el pago con tarjeta. Al confirmarse recibirás tu comprobante por correo.",
    q2: "¿Puedo cancelar mi reserva?",
    a2: "Sí. Cambio de fecha gratis hasta 24 h antes, sujeto a disponibilidad. Con más de 24 h: reembolso del total menos 5% de cargo administrativo. Con menos de 24 h o no presentarse: sin reembolso. Por clima o por el operador: reembolso total o cambio de fecha. Si la página del tour muestra condiciones más flexibles, aplican esas.",
    q3: "¿Los tours incluyen transporte?",
    a3: "Muchos tours incluyen transporte desde puntos de encuentro definidos. Revisa la sección de qué incluye en cada experiencia antes de reservar.",
    q4: "¿Qué métodos de pago aceptan?",
    a4: "Aceptamos tarjetas de crédito y débito mediante un proceso de pago seguro. Algunos tours con proveedor asociado se pagan en su plataforma.",
    q5: "¿Los tours están disponibles en español?",
    a5: "Sí, contamos con experiencias guiadas en español y también opciones en otros idiomas. El idioma disponible aparece en cada actividad.",
    q6: "¿Cómo me contactan después de reservar?",
    a6: "Te contactamos por correo con los detalles de tu actividad: punto de encuentro, horario y recomendaciones. También puedes escribirnos por WhatsApp.",
    q8: '¿Por qué aparece MMEXICO o LADYGUIA en mi pago?',
    q7: "¿Cómo recibo mi voucher?",
    a7: "Al confirmarse el pago recibes tu voucher por correo electrónico con el código de tu reserva. Muéstralo el día de la actividad.",
  },
} satisfies Dict;

export type Translations = typeof es;
